module.exports = __webpack_public_path__ + "media/images/signup-sean-morton-5da30f215c9a53ea567211d39c55804a.jpg";